"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStructureComparison = exports.FormStructureInstanceKind = void 0;
const comparison_spec_1 = require("../comparison-spec");
var FormStructureInstanceKind;
(function (FormStructureInstanceKind) {
    FormStructureInstanceKind["BlockInstance"] = "block_instance";
    FormStructureInstanceKind["ArrayElement"] = "array_element";
})(FormStructureInstanceKind || (exports.FormStructureInstanceKind = FormStructureInstanceKind = {}));
class FormStructureComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.SetAlignment();
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return this.alignment.identityOf(row, (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
}
exports.FormStructureComparison = FormStructureComparison;
//# sourceMappingURL=form-structure.comparison.js.map